import { ErrorBoundary } from "@/shared/components/error-boundary";
import type { ReactNode } from "react";
import { Sidebar } from "./sidebar";
import { useSidebarStore } from "./sidebar-store";
import { TopBar } from "./top-bar";

interface AppShellProps {
  children: ReactNode;
  /** Slot vpravo v TopBaru — dodává routa (NotificationBell, ThemeToggle apod.). */
  topBarActions?: ReactNode;
}

/**
 * Hlavní rozložení dashboardu. Fixní sidebar (260px) vlevo na desktopu,
 * na mobilu se sidebar skrývá a otevírá přes hamburger v TopBar.
 */
export function AppShell({ children, topBarActions }: AppShellProps) {
  // Fills its parent (the dashboard's flex column). The sidebar gets exactly
  // the remaining height, and `main` scrolls internally — so the sidebar's
  // footer (settings/logout) is never clipped, regardless of page length.
  const collapsed = useSidebarStore((s) => s.collapsed);
  return (
    <div
      className={`grid h-full grid-cols-1 ${collapsed ? "md:grid-cols-[68px_1fr]" : "md:grid-cols-[260px_1fr]"}`}
      data-testid="app-shell"
    >
      <div className="hidden h-full min-h-0 md:block">
        <Sidebar />
      </div>
      <div className="flex h-full min-h-0 flex-col">
        <TopBar actions={topBarActions} />
        <main
          id="main-content"
          className="min-h-0 flex-1 overflow-y-auto bg-background px-4 py-6 md:px-8 md:py-8"
          data-testid="app-main"
        >
          <ErrorBoundary>{children}</ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
